/** @jsxImportSource @emotion/react */
import * as s from './style'
import React, { useState } from 'react';

import { PiPolygonFill } from "react-icons/pi";
import { GoDotFill } from "react-icons/go";

import { BsThreeDotsVertical } from "react-icons/bs";
import { IoMdEye } from "react-icons/io";
import { IoMdEyeOff } from "react-icons/io";


const icons = [
    {
        id: 0,
        name: "POLYGON",
        icon: <PiPolygonFill />
    }, {
        id: 1,
        name: "POINT",
        icon: <GoDotFill />
    }
]

const SidemenuLayerItem = ({ data, map, isLoading }) => {
    const icon = icons.find((icon) => icon.name === data.layerType).icon;

    const [ hover, setHover ] = useState(false);
    const [ visible, setVisible ] = useState(data.id === 'bjd_layer' ? true : false);

    const onClickHideButton = () => {
        if(!isLoading) {
            const layers = map.getLayers().getArray();
            const thisLayer = layers.find((layer) => layer.get("layerName") === data.id);
            thisLayer.setVisible(!thisLayer.getVisible());
            setVisible(thisLayer.getVisible());
        }
    }

    return (
        <div css={s.mainContainer} onMouseOver={() => setHover(true)} onMouseLeave={() => setHover(false)}>
            <div css={s.header}>
                <div css={s.type}>
                    <span css={s.icon(data.id)}>{icon}</span>
                    <span css={s.typeText}>{data.layerType}</span>
                </div>
                <p css={s.nameText}>{data.name}</p>
            </div>
            <div css={s.buttonContainer}>
                <button css={[s.button, s.hover(hover)]} onClick={onClickHideButton}>{visible ? <IoMdEye/> : <IoMdEyeOff/>}</button>
                {/* <button css={s.button}><BsThreeDotsVertical /></button> */}
            </div>
        </div>
    );
};

export default SidemenuLayerItem;